import { RouteRecordRaw } from "vue-router";
import Layout from "@/views/layouts/index.vue";

const userMessageRouters: RouteRecordRaw[] = [
    {
        path: "/userMessage",
        name: "UserMessage",
        meta: {
            title: "消息中心",
            icon: "icon-xiaoxi",
            hidden: true
        },
        component: Layout,
        redirect: "/userMessage/",
        children: [
            {
                path: "/userMessage/",
                name: "UserMessageList",
                meta: { title: "我的消息", hidden: true, activeMenu: "UserMessage" },
                component: () => import("@/views/pages/userMessage/index.vue")
            }
        ]
    }
];

export default userMessageRouters;
